import {createAction, createActionGroup, props} from '@ngrx/store';
import {EditTemplateStoreFeatureKey} from './edit-template-store.config';
import {TemplateForm} from '../edit-template.dto';
import {HttpErrorResponse} from '@angular/common/http';
import {IGuideLineListFilter} from "../../legal-hub/playbooks/playbook-list/playbook-list.component";
import {IPlaybooksItemDTO} from "../../legal-hub/dto/playbooks-listening.dto";
import { IGroup } from '../../settings/documenttype/document-type-settings-modal/document-type-settings.dto';
import { IDocumentTypesDto } from '../../documents/dto/document-listing.dto';

export const scope = `[${EditTemplateStoreFeatureKey}]`;

export const loadTemplate = createAction(`${scope} Load Template`, props<{ id: string, route: string }>());
export const loadTemplateSuccess = createAction(`${scope} Load Template Success`, (template: TemplateForm) => ({template}));
export const loadTemplateFailure = createAction(`${scope} Load Template Failure`, (error: HttpErrorResponse) => ({error}));
export const setTemplateRoute = createAction(`set route params`, props<{ routeState: { id: number, route: string } }>());
export const clearTemplateRoute = createAction(`clear route params`);
export const clearState = createAction(`${scope} Clear template state`);

export const DocumentTypeSettingsActions = createActionGroup({
    source: scope,
    events: {
     'Change document type': props<{id: number}>(),
     'Change document type success': props<{groups: IGroup[]}>(),
     'Change document type failure': props<{error: HttpErrorResponse}>()  
    }
});

export const rightBarHigherZindex = createAction(`${scope} Right bar higher z-index`, props<{ higher: boolean }>());

/*Legal Hub*/
export const setLegalHubFilters = createAction(`${scope} Set Legal Hub Filters`, props<{ filters: IGuideLineListFilter }>());
export const selectLegalHubPlaybook = createAction(`${scope} Set Legal Hub Selected Playbook`, props<{ playbook: IPlaybooksItemDTO }>());
export const legalHubSuggestionDestroyed = createAction(`${scope} Legal Hub Suggestion Destroyed`);